module.exports = {
	"/": {
		"namespace": "",
		"methods": [
			"GET"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {}
				}
			}
		]
	},
	"/oembed/1.0": {
		"namespace": "oembed/1.0",
		"methods": [
			"GET"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"namespace": {},
					"context": {}
				}
			}
		]
	},
	"/oembed/1.0/embed": {
		"namespace": "oembed/1.0",
		"methods": [
			"GET"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"url": {},
					"format": {},
					"maxwidth": {}
				}
			}
		]
	},
	"/wp/v2": {
		"namespace": "wp/v2",
		"methods": [
			"GET"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"namespace": {},
					"context": {}
				}
			}
		]
	},
	"/wp/v2/posts": {
		"namespace": "wp/v2",
		"methods": [
			"GET",
			"POST"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {},
					"page": {},
					"per_page": {},
					"search": {},
					"after": {},
					"author": {},
					"author_exclude": {},
					"before": {},
					"exclude": {},
					"include": {},
					"offset": {},
					"order": {},
					"orderby": {},
					"slug": {},
					"status": {},
					"categories": {},
					"categories_exclude": {},
					"tags": {},
					"tags_exclude": {},
					"sticky": {}
				}
			},
			{
				"methods": [
					"POST"
				],
				"args": {
					"date": {},
					"date_gmt": {},
					"slug": {},
					"status": {},
					"password": {},
					"title": {},
					"content": {},
					"author": {},
					"excerpt": {},
					"featured_media": {},
					"comment_status": {},
					"ping_status": {},
					"format": {},
					"meta": {},
					"sticky": {},
					"template": {},
					"categories": {},
					"tags": {}
				}
			}
		]
	},
	"/wp/v2/posts/(?P<id>[\\d]+)": {
		"namespace": "wp/v2",
		"methods": [
			"GET",
			"POST",
			"PUT",
			"PATCH",
			"DELETE"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {},
					"password": {}
				}
			},
			{
				"methods": [
					"POST",
					"PUT",
					"PATCH"
				],
				"args": {
					"date": {},
					"date_gmt": {},
					"slug": {},
					"status": {},
					"password": {},
					"title": {},
					"content": {},
					"author": {},
					"excerpt": {},
					"featured_media": {},
					"comment_status": {},
					"ping_status": {},
					"format": {},
					"meta": {},
					"sticky": {},
					"template": {},
					"categories": {},
					"tags": {}
				}
			},
			{
				"methods": [
					"DELETE"
				],
				"args": {
					"force": {}
				}
			}
		]
	},
	"/wp/v2/posts/(?P<parent>[\\d]+)/revisions": {
		"namespace": "wp/v2",
		"methods": [
			"GET"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {}
				}
			}
		]
	},
	"/wp/v2/posts/(?P<parent>[\\d]+)/revisions/(?P<id>[\\d]+)": {
		"namespace": "wp/v2",
		"methods": [
			"GET",
			"DELETE"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {}
				}
			},
			{
				"methods": [
					"DELETE"
				],
				"args": {
					"force": {}
				}
			}
		]
	},
	"/wp/v2/pages": {
		"namespace": "wp/v2",
		"methods": [
			"GET",
			"POST"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {},
					"page": {},
					"per_page": {},
					"search": {},
					"after": {},
					"author": {},
					"author_exclude": {},
					"before": {},
					"exclude": {},
					"include": {},
					"menu_order": {},
					"offset": {},
					"order": {},
					"orderby": {},
					"parent": {},
					"parent_exclude": {},
					"slug": {},
					"status": {}
				}
			},
			{
				"methods": [
					"POST"
				],
				"args": {
					"date": {},
					"date_gmt": {},
					"slug": {},
					"status": {},
					"password": {},
					"parent": {},
					"title": {},
					"content": {},
					"author": {},
					"excerpt": {},
					"featured_media": {},
					"comment_status": {},
					"ping_status": {},
					"menu_order": {},
					"meta": {},
					"template": {}
				}
			}
		]
	},
	"/wp/v2/pages/(?P<id>[\\d]+)": {
		"namespace": "wp/v2",
		"methods": [
			"GET",
			"POST",
			"PUT",
			"PATCH",
			"DELETE"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {},
					"password": {}
				}
			},
			{
				"methods": [
					"POST",
					"PUT",
					"PATCH"
				],
				"args": {
					"date": {},
					"date_gmt": {},
					"slug": {},
					"status": {},
					"password": {},
					"parent": {},
					"title": {},
					"content": {},
					"author": {},
					"excerpt": {},
					"featured_media": {},
					"comment_status": {},
					"ping_status": {},
					"menu_order": {},
					"meta": {},
					"template": {}
				}
			},
			{
				"methods": [
					"DELETE"
				],
				"args": {
					"force": {}
				}
			}
		]
	},
	"/wp/v2/pages/(?P<parent>[\\d]+)/revisions": {
		"namespace": "wp/v2",
		"methods": [
			"GET"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {}
				}
			}
		]
	},
	"/wp/v2/pages/(?P<parent>[\\d]+)/revisions/(?P<id>[\\d]+)": {
		"namespace": "wp/v2",
		"methods": [
			"GET",
			"DELETE"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {}
				}
			},
			{
				"methods": [
					"DELETE"
				],
				"args": {
					"force": {}
				}
			}
		]
	},
	"/wp/v2/media": {
		"namespace": "wp/v2",
		"methods": [
			"GET",
			"POST"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {},
					"page": {},
					"per_page": {},
					"search": {},
					"after": {},
					"author": {},
					"author_exclude": {},
					"before": {},
					"exclude": {},
					"include": {},
					"offset": {},
					"order": {},
					"orderby": {},
					"parent": {},
					"parent_exclude": {},
					"slug": {},
					"status": {},
					"media_type": {},
					"mime_type": {}
				}
			},
			{
				"methods": [
					"POST"
				],
				"args": {
					"date": {},
					"date_gmt": {},
					"slug": {},
					"status": {},
					"title": {},
					"author": {},
					"comment_status": {},
					"ping_status": {},
					"meta": {},
					"template": {},
					"alt_text": {},
					"caption": {},
					"description": {},
					"post": {}
				}
			}
		]
	},
	"/wp/v2/media/(?P<id>[\\d]+)": {
		"namespace": "wp/v2",
		"methods": [
			"GET",
			"POST",
			"PUT",
			"PATCH",
			"DELETE"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {},
					"password": {}
				}
			},
			{
				"methods": [
					"POST",
					"PUT",
					"PATCH"
				],
				"args": {
					"date": {},
					"date_gmt": {},
					"slug": {},
					"status": {},
					"title": {},
					"author": {},
					"comment_status": {},
					"ping_status": {},
					"meta": {},
					"template": {},
					"alt_text": {},
					"caption": {},
					"description": {},
					"post": {}
				}
			},
			{
				"methods": [
					"DELETE"
				],
				"args": {
					"force": {}
				}
			}
		]
	},
	"/wp/v2/types": {
		"namespace": "wp/v2",
		"methods": [
			"GET"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {}
				}
			}
		]
	},
	"/wp/v2/types/(?P<type>[\\w-]+)": {
		"namespace": "wp/v2",
		"methods": [
			"GET"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {}
				}
			}
		]
	},
	"/wp/v2/statuses": {
		"namespace": "wp/v2",
		"methods": [
			"GET"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {}
				}
			}
		]
	},
	"/wp/v2/statuses/(?P<status>[\\w-]+)": {
		"namespace": "wp/v2",
		"methods": [
			"GET"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {}
				}
			}
		]
	},
	"/wp/v2/taxonomies": {
		"namespace": "wp/v2",
		"methods": [
			"GET"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {},
					"type": {}
				}
			}
		]
	},
	"/wp/v2/taxonomies/(?P<taxonomy>[\\w-]+)": {
		"namespace": "wp/v2",
		"methods": [
			"GET"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {}
				}
			}
		]
	},
	"/wp/v2/categories": {
		"namespace": "wp/v2",
		"methods": [
			"GET",
			"POST"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {},
					"page": {},
					"per_page": {},
					"search": {},
					"exclude": {},
					"include": {},
					"order": {},
					"orderby": {},
					"hide_empty": {},
					"parent": {},
					"post": {},
					"slug": {}
				}
			},
			{
				"methods": [
					"POST"
				],
				"args": {
					"description": {},
					"name": {},
					"slug": {},
					"parent": {},
					"meta": {}
				}
			}
		]
	},
	"/wp/v2/categories/(?P<id>[\\d]+)": {
		"namespace": "wp/v2",
		"methods": [
			"GET",
			"POST",
			"PUT",
			"PATCH",
			"DELETE"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {}
				}
			},
			{
				"methods": [
					"POST",
					"PUT",
					"PATCH"
				],
				"args": {
					"description": {},
					"name": {},
					"slug": {},
					"parent": {},
					"meta": {}
				}
			},
			{
				"methods": [
					"DELETE"
				],
				"args": {
					"force": {}
				}
			}
		]
	},
	"/wp/v2/tags": {
		"namespace": "wp/v2",
		"methods": [
			"GET",
			"POST"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {},
					"page": {},
					"per_page": {},
					"search": {},
					"exclude": {},
					"include": {},
					"offset": {},
					"order": {},
					"orderby": {},
					"hide_empty": {},
					"post": {},
					"slug": {}
				}
			},
			{
				"methods": [
					"POST"
				],
				"args": {
					"description": {},
					"name": {},
					"slug": {},
					"meta": {}
				}
			}
		]
	},
	"/wp/v2/tags/(?P<id>[\\d]+)": {
		"namespace": "wp/v2",
		"methods": [
			"GET",
			"POST",
			"PUT",
			"PATCH",
			"DELETE"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {}
				}
			},
			{
				"methods": [
					"POST",
					"PUT",
					"PATCH"
				],
				"args": {
					"description": {},
					"name": {},
					"slug": {},
					"meta": {}
				}
			},
			{
				"methods": [
					"DELETE"
				],
				"args": {
					"force": {}
				}
			}
		]
	},
	"/wp/v2/users": {
		"namespace": "wp/v2",
		"methods": [
			"GET",
			"POST"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {},
					"page": {},
					"per_page": {},
					"search": {},
					"exclude": {},
					"include": {},
					"offset": {},
					"order": {},
					"orderby": {},
					"slug": {},
					"roles": {}
				}
			},
			{
				"methods": [
					"POST"
				],
				"args": {
					"username": {},
					"name": {},
					"first_name": {},
					"last_name": {},
					"email": {},
					"url": {},
					"description": {},
					"locale": {},
					"nickname": {},
					"slug": {},
					"roles": {},
					"password": {},
					"meta": {}
				}
			}
		]
	},
	"/wp/v2/users/(?P<id>[\\d]+)": {
		"namespace": "wp/v2",
		"methods": [
			"GET",
			"POST",
			"PUT",
			"PATCH",
			"DELETE"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {}
				}
			},
			{
				"methods": [
					"POST",
					"PUT",
					"PATCH"
				],
				"args": {
					"username": {},
					"name": {},
					"first_name": {},
					"last_name": {},
					"email": {},
					"url": {},
					"description": {},
					"locale": {},
					"nickname": {},
					"slug": {},
					"roles": {},
					"password": {},
					"meta": {}
				}
			},
			{
				"methods": [
					"DELETE"
				],
				"args": {
					"force": {},
					"reassign": {}
				}
			}
		]
	},
	"/wp/v2/users/me": {
		"namespace": "wp/v2",
		"methods": [
			"GET",
			"POST",
			"PUT",
			"PATCH",
			"DELETE"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {}
				}
			},
			{
				"methods": [
					"POST",
					"PUT",
					"PATCH"
				],
				"args": {
					"username": {},
					"name": {},
					"first_name": {},
					"last_name": {},
					"email": {},
					"url": {},
					"description": {},
					"locale": {},
					"nickname": {},
					"slug": {},
					"roles": {},
					"password": {},
					"meta": {}
				}
			},
			{
				"methods": [
					"DELETE"
				],
				"args": {
					"force": {},
					"reassign": {}
				}
			}
		]
	},
	"/wp/v2/comments": {
		"namespace": "wp/v2",
		"methods": [
			"GET",
			"POST"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {},
					"page": {},
					"per_page": {},
					"search": {},
					"after": {},
					"author": {},
					"author_exclude": {},
					"author_email": {},
					"before": {},
					"exclude": {},
					"include": {},
					"offset": {},
					"order": {},
					"orderby": {},
					"parent": {},
					"parent_exclude": {},
					"post": {},
					"status": {},
					"type": {},
					"password": {}
				}
			},
			{
				"methods": [
					"POST"
				],
				"args": {
					"author": {},
					"author_email": {},
					"author_ip": {},
					"author_name": {},
					"author_url": {},
					"author_user_agent": {},
					"content": {},
					"date": {},
					"date_gmt": {},
					"parent": {},
					"post": {},
					"status": {},
					"meta": {}
				}
			}
		]
	},
	"/wp/v2/comments/(?P<id>[\\d]+)": {
		"namespace": "wp/v2",
		"methods": [
			"GET",
			"POST",
			"PUT",
			"PATCH",
			"DELETE"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {
					"context": {},
					"password": {}
				}
			},
			{
				"methods": [
					"POST",
					"PUT",
					"PATCH"
				],
				"args": {
					"author": {},
					"author_email": {},
					"author_ip": {},
					"author_name": {},
					"author_url": {},
					"author_user_agent": {},
					"content": {},
					"date": {},
					"date_gmt": {},
					"parent": {},
					"post": {},
					"status": {},
					"meta": {}
				}
			},
			{
				"methods": [
					"DELETE"
				],
				"args": {
					"force": {},
					"password": {}
				}
			}
		]
	},
	"/wp/v2/settings": {
		"namespace": "wp/v2",
		"methods": [
			"GET",
			"POST",
			"PUT",
			"PATCH"
		],
		"endpoints": [
			{
				"methods": [
					"GET"
				],
				"args": {}
			},
			{
				"methods": [
					"POST",
					"PUT",
					"PATCH"
				],
				"args": {
					"title": {},
					"description": {},
					"url": {},
					"email": {},
					"timezone": {},
					"date_format": {},
					"time_format": {},
					"start_of_week": {},
					"language": {},
					"use_smilies": {},
					"default_category": {},
					"default_post_format": {},
					"posts_per_page": {},
					"default_ping_status": {},
					"default_comment_status": {}
				}
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./lib/data/default-routes.json
// module id = 5
// module chunks = 0